import { useState } from "react";
import { styled } from "styled-components";
import { File, Image } from "@ludens-reklame/rubics-v3-sdk/file/types";
import { VideoModal } from "../../internal-components/VideoModal.js";
import { transformImageUrl } from "@ludens-reklame/rubics-v3-sdk/file/utils";
import { Constrainer } from "../../internal-components/Layout.js";

export interface Props {
  video?: File;
  videoUrl?: string;
  videoEmbed?: string;
  text?: string;
  image?: Image;
}
export const VideoComponent: React.FunctionComponent<Props> = ({
  video,
  videoUrl,
  videoEmbed,
  text,
  image,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleModalOpen = () => {
    setIsModalOpen(true);
  };
  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  if (!video && !videoUrl && !videoEmbed) {
    return null;
  }

  return (
    <Constrainer>
      <VideoContainer onClick={handleModalOpen}>
        {image && (
          <img src={transformImageUrl(image, {})} alt={image.altText || ""} />
        )}
        {text && <h2>{text}</h2>}
        <Icon>
          <img src="https://res.cloudinary.com/rubics/image/upload/v1727247211/66f3b36a8da1c3533822c3dc-c1f45c7cadcf7eed9e2f129ae8af3b48.gif" />
        </Icon>
        <VideoModal
          isOpen={isModalOpen}
          onClose={handleModalClose}
          video={video}
          videoUrl={videoUrl}
          videoEmbed={videoEmbed}
        />
      </VideoContainer>
    </Constrainer>
  );
};

const Icon = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100px;
  height: 100px;
`;

const VideoContainer = styled.div`
margin: 0 auto;
  position: relative;
  cursor: pointer;
  height: 450px;
  max-width: 1440px;
  h2 {
  position: absolute;
  bottom: 55%;
  left: 50%;
  transform: translate(-50%, -50%);
    color: white;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
`;
